import React, {Component} from "react";
import NProgress from "nprogress";
import 'nprogress/nprogress.css'

export default function asyncComponent(importComponent) {
    class AsyncComponent extends Component {
        constructor(props) {
            super(props);

            this.state = {
                component: null
            };
        }

        async componentDidMount() {
            NProgress.start();
            const {default: component} = await importComponent();
            NProgress.done();
            this.setState({
                component: component
            });
        }

        render() {
            const C = this.state.component;

            return C ? <C {...this.props} /> : null;
        }
    }

    return AsyncComponent;
}